const BrowserFS = require('browserfs')

export { BrowserFS }
